<template>
  <div class="auth-wrapper auth-v1 px-2 bg-img">
    <div class="auth-inner py-2" style="max-width: 60%;">

      <!-- Login v1 -->
      <div>
        <b-card class="mb-0">
          <div class="">
            <b-row
              class="no-gutter d-flex align-items-center"
            >
              <b-col
                class="d-none d-lg-block"
                cols="6"
                lg="6"
              >
                <img src="@/assets/images/pages/forgot-password.webp" alt="login" style="margin: 0px 90px">
              </b-col>
              <b-col
                class=""
                xs="12"
                sm="12"
                md="12"
                lg="6"
              >
                <b-overlay
                :show="mostrarLoader"
                opacity="0.50"
                rounded="sm"
                spinner-variant="primary"
                spinner-type="grow"
                >
                  <div>
                    <div class="vx-card__title">
                      <h4 class="">Recuperación de contraseña</h4>
                      <p>Ingrese su correo electrónico con el que se registró para enviarle las instrucciones de reinicio de contraseña.</p>
                    </div>

                    <b-form-group>
                      <b-input name="email" type="email" label-placeholder="Email" v-model="email" class="w-full" v-validate="'required|email|max:50'" :class="[{'is-invalid': errors.has('email')}]" maxlength="50" placeholder="Email"/>
                      <span class="text-danger text-sm" v-show="errors.has('email')">{{  errors.first('email') }}</span>
                    </b-form-group>

                    <b-row class="mt-3">
                      <b-col cols="12" xl="6" md="12"><b-button variant="outline-primary" :disabled="bloquearBtn" type="border" to="/login/" class="w-full md:w-auto md:mt-8">Iniciar sesión</b-button></b-col>
                      <b-col cols="12" xl="6"><b-button variant="primary" :disabled="bloquearBtn"  class="float-right w-full md:w-auto mb-8 md:mt-0 md:mb-0 md:mt-8" @click="submitForm">Recuperar</b-button></b-col>
                    </b-row>
                  </div>
                </b-overlay>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
import axios from "@/axios";
Validator.localize("es", es);

export default {
  data () {
    return {
      email: '',
      bloquearBtn: false,
      mostrarLoader: false,
    }
  },
    methods: {
      submitForm: function(){
        this.openLoadingContained();
        this.$validator.validateAll().then(result => {
          if (result) {
            // if form have no errors
            this.solicitarReset();
          } else {
            this.closeLoadingContained();
          }
        });
      },

      solicitarReset(){
        axios.post('api/recuperar_credenciales/enviar_email_recuperacion_clave/',
        {email: this.email}
        ).then(response => {
          if ( "error"== response.data.status ){
            this.$swal({
              title: 'Error!',
              text: response.data.mensaje,
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
              confirmButtonText: 'Aceptar',
            })
          }else{
            this.$swal({
              title: 'Registro exitoso',
              text: response.data.mensaje,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
              confirmButtonText: 'Aceptar',
            }).then((result) => {
                this.redirigirALogin()
            });
          }
          this.closeLoadingContained();
        });
      },

      openLoadingContained(){
        this.bloquearBtn = true
        this.mostrarLoader = true
      },

      closeLoadingContained(){
        this.bloquearBtn = false
        this.mostrarLoader = false
      },

      redirigirALogin(){
          this.$router.push("/login/")
      },
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
